import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import api from '@/lib/api';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export default function FAQ() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/public/settings').then(res => {
      setSettings(res.data);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  // Helper per ottenere testi CMS con fallback
  const t = (key, fallback) => settings?.texts?.[key] || fallback;

  if (loading) {
    return (
      <div className="min-h-screen pt-32 flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Caricamento...</div>
      </div>
    );
  }

  const faqs = settings?.faq || [];

  return (
    <div className="pt-32 pb-24" data-testid="faq-page">
      {/* Header */}
      <div className="max-w-3xl mx-auto px-6 lg:px-12 mb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="text-sm tracking-[0.2em] uppercase text-muted-foreground">FAQ</span>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl mt-4 mb-6">
            {t('page_faq_title', 'Domande Frequenti')}
          </h1>
          <p className="font-accent text-xl text-muted-foreground">
            {t('page_faq_subtitle', 'Risposte alle domande più comuni sui miei servizi.')}
          </p>
        </motion.div>
      </div>

      {/* FAQ List */}
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        {faqs.length > 0 ? (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`faq-${index}`}
                  className="border-border"
                  data-testid={`faq-item-${index}`}
                >
                  <AccordionTrigger className="text-left text-lg font-heading hover:no-underline py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        ) : (
          <div className="text-center py-16 text-muted-foreground">
            {t('faq_empty', 'Nessuna FAQ disponibile al momento.')}
          </div>
        )}
      </div>
    </div>
  );
}
